import { gql } from "@apollo/client";

const RECIPE_QA = gql`
  query recipeQA($id: ID!, $engine: String) {
    recipeQa(id: $id, engine: $engine) {
      recipeId
      name
      engine
      model
      totalIssues
      checks
      inputTokens
      durationMs
      counts {
        category
        count
      }
      issues {
        category
        source
        quote
        quoteFound
        reason
        severity
        probability
      }
    }
  }
`;

export default RECIPE_QA;
